export const imgProps = {
  objectFit: 'cover',
  backgroundPosition: 'center'
}
